<template>
    <span class="ah-el-select-staff">
        <el-select
            class="text-cursor"
            v-model="inputVal"
            placeholder="請選擇"
            no-data-text="無資料"
            no-match-text="無相關資料"
            :filterable="true"
            :filter-method="filterMethod"
            @keydown.native.capture.enter="preventIMESelect"
        >
            <el-option class="staff-item" v-for="item in optionsCopy" :key="item.sno" :label="item.nam" :value="item.sno">
                <div class="main clearfix">
                    <div class="name">{{ item.nam }}</div>
                    <div class="dep" v-if="item.deP_NAM">{{ item.deP_NAM }}</div>
                </div>
                <div class="sub">
                    <div class="email">{{ item.eml }}</div>
                </div>
            </el-option>
        </el-select>
    </span>
</template>
<script>
export default {
    name: 'ah-el-select-staff',
    props: ['value'],
    components: {},
    data() {
        return {
            options: [],
            optionsCopy: [],
        };
    },
    computed: {
        inputVal: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
    mounted() {
        this.fetchData();
    },
    methods: {
        // 取得下拉選單資料
        fetchData() {
            this.$api({
                url: '/StaffManagementPage/GetStaffList',
                params: {
                    PageSize: 999,
                    PageNum: 1,
                    TYP: 1,
                    ONF: 1,
                },
                method: 'GET',
            }).then((resp) => {
                this.options = resp.data.staffs.reverse().filter((x) => x.sno !== 1);
                this.optionsCopy = this.options.filter(() => true);
            });
        },

        // 輸入時過濾方法
        filterMethod(val) {
            // 搜尋
            if (val) {
                this.optionsCopy = this.options.filter(
                    (item) =>
                        // 比對
                        item.nam.toLowerCase().indexOf(val.toLowerCase()) > -1 || item.eml.toLowerCase().indexOf(val.toLowerCase()) > -1,
                );
            } else {
                this.optionsCopy = this.options.filter(() => true);
            }
        },
        preventIMESelect(e) {
            // keyCode 229 代表輸入法正在輸入
            if (e.keyCode === 229 || e.isComposing) {
                // 停止事件冒泡，防止觸發 Element-UI 內部的 handleKeydown
                e.stopPropagation();
            }
        },
    },
};
</script>
<style lang="scss">
.ah-el-select-staff {
    .el-input {
        min-width: 260px;
    }

    .el-input > input {
        cursor: text;
    }
}

.el-select-dropdown__item.staff-item {
    padding-top: 3px;
    height: 59px;

    .main {
        display: block;

        .name {
            float: left;
            padding-top: 0px;
            height: 28px;
        }

        .dep {
            float: right;
            margin-left: 10px;
            font-size: 9pt;
            font-weight: normal;
            color: #bbb;
        }
    }

    .sub {
        .email {
            position: relative;
            top: -5px;
            font-size: 9pt;
            color: #ccc;
            height: 15px;
            line-height: 15px;
            font-weight: normal;
        }
    }

    .clearfix:before,
    .clearfix:after {
        content: "";
        display: table;
    }

    .clearfix:after {
        clear: both;
    }

    .clearfix {
        *zoom: 1;
        /*For IE 6&7 only*/
    }
}
</style>
